import http from '@/http'
import { DraftImage } from '@/interfaces/admin'

export async function putSheetOrderBy (pageId: string, orderArray: Array<any>): Promise<DraftImage[]> {
  const { data } = await http.put(`/admin/draft-sheets/display-order/${pageId}`, orderArray)
  return data
}
